var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('el-container',[_c('el-header',{attrs:{"height":"80px"}},[_c('app-header')],1),_c('el-main',[_c('router-view')],1),_c('el-footer',{attrs:{"height":"400px"}},[_c('app-footer')],1),_c('floating-contact-buttons')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }